<template>
  <div class="tw:flex tw:gap-12 tw:items-center tw:w-full">
    <SliderBaseAntd
      v-bind="filteredAttrs"
      :model-value="sliderValue"
      show-value
      @update:model-value="handleUpdate"
    />
  </div>
</template>
<script lang="ts" setup>
import SliderBaseAntd from '@/components/base/antd/SliderBaseAntd.vue'
import { useAttrs, computed } from 'vue'

defineOptions({
  name: 'mars-slider',
  inheritAttrs: false,
})

const attrs = useAttrs()

const emit = defineEmits(['update:value', 'change'])

// Get value from attrs.value
const sliderValue = computed(() => {
  return (attrs.value as number) ?? 0
})

// Filter out value from attrs to avoid conflict
const filteredAttrs = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { value, 'onUpdate:value': onUpdateValue, ...rest } = attrs
  return rest
})

const handleUpdate = (val: number | number[]) => {
  emit('update:value', val)
  emit('change', val)
}
</script>
